import React from 'react';
import { TextReveal } from './TextReveal';
const services = [{
  id: '01',
  title: 'GRÜNDUNGSBERATUNG',
  description: 'Von der Rechtsformwahl bis zur notariellen Beurkundung. Wir begleiten den gesamten Gründungsprozess Ihres Unternehmens.'
}, {
  id: '02',
  title: 'STRUKTURIERUNG',
  description: 'Holding-Strukturen, Beteiligungsmodelle und gesellschaftsrechtliche Optimierung für maximale Effizienz.'
}, {
  id: '03',
  title: 'GESCHÄFTSFÜHRER-BERATUNG',
  description: 'Haftungsmanagement, Vergütungsoptimierung und strategische Positionierung des Unternehmens und der Geschäftsführung.'
}, {
  id: '04',
  title: 'NACHFOLGEPLANUNG',
  description: 'Strukturierte Übergabeprozesse, Bewertung und steueroptimierte Nachfolgeregelungen.'
}];
export function Services() {
  return <section className="py-24 md:py-32 bg-bg" data-id="element-101">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl" data-id="element-102">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-103">
          <div className="md:col-span-3" data-id="element-104">
            <TextReveal text="LEISTUNGEN" as="h2" className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-muted sticky top-32" data-id="element-105" />
          </div>

          <div className="md:col-span-9 space-y-24 md:space-y-32" data-id="element-106">
            {services.map(service => <div key={service.id} className="group" data-id="element-107">
                <div className="mb-4 overflow-hidden" data-id="element-108">
                  <TextReveal text={service.id} as="span" className="text-6xl md:text-8xl font-black text-lime block leading-none tracking-tighter" data-id="element-109" />
                </div>
                <div className="mb-6" data-id="element-110">
                  <TextReveal text={service.title} as="h3" className="text-2xl md:text-4xl font-bold text-white uppercase tracking-tight" delay={0.1} data-id="element-111" />
                </div>
                <div className="max-w-xl" data-id="element-112">
                  <TextReveal text={service.description} as="p" className="text-lg text-muted leading-relaxed" delay={0.2} data-id="element-113" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}